<template lang="pug">
.cp-core
  top-title(topType="core", @showModal="showModal")
  .page1
    .wrap.first-core.w
      .title 激发数据潜能，实现增长跃迁
      .list
        .item(v-for="(item,index) in list" :key="index" )
          img(:src="item.img" :alt="item.title")
          .item-title {{item.title}}
          .item-desc {{item.desc}}
    .w
      .title(style="margin-top:281px") 智能语音对话内核，成就非凡互动体验
      .core-tabs
        .tabs
          .tabs-item(v-for="(item, index) in coreTabs", :class="{active: index === activeTab }", @click="handleTabClick(index)")
            img(:src="item.icon")
            span {{item.title}}
        ul.plan
          li(v-for="item in coreTabs[activeTab].items")
            img(:src="item.icon")
            h5 {{item.title}}
            p {{item.content}}
      .title(style="padding-top: 200px") 多维度高标准安全策略，保障企业信息安全
      .subtitle 已通过公安部网络信息系统安全等级保护认证
      ul.safe-list
        li
          img(src="../../assets/icon-safe1.png")
          .info
            h4 物理安全控制策略
            p 多地数据备份，高可用性
            p 至少N+1冗余的系统容灾能力
        li
          img(src="../../assets/icon-safe2.png")
          .info
            h4 网络安全控制策略
            p 硬件防火墙和软件防火墙双重保护攻击防护、入侵检测
        li
          img(src="../../assets/icon-safe3.png")
          .info
            h4 数据安全控制策略
            p 256位SSL/TLS加密
            p OAuth2.0鉴权方案
            p CDN就近传输优化
        li
          img(src="../../assets/icon-safe4.png")
          .info
            h4 应用安全控制策略
            p 身份验证
            p 客户端进程防注入
        li
          img(src="../../assets/icon-safe5.png")
          .info
            h4 系统安全控制策略
            p 前端负载均衡
            p 快速的补丁分发能力
        li
          img(src="../../assets/icon-safe6.png")
          .info
            h4 管理安全控制策略
            p 核心功能多级代码审查
            p 人员安全管理
            p 企业的个性化权限分配选择
      .certificate-list
        .item(v-for="(item, index) in certificateList" :key="index" )
          img(:src="item.img")
          p {{item.title}}

      .title(style="padding-top: 160px") 老牌劲旅，十年企业信息技术专家
      ul.team
        li.team1
          h4 核心技术团队
          p 『去电人工智能』，由一支持续创业多年的企业应用团队发起于2016年底(该团队组建于2013年)。其核心成员均为从业10年以上的信息技术专家，来自于阿里巴巴、腾讯、贝尔、华为等知名科技企业。其中AI算法团队是一支来自国际知名学府的博士团队，多位专家发表的领域论著在数家国际权威期刊发表。
        li.team2
          h4 团队成员
          p 团队成员多数毕业于海内外高等院校。包括武汉大学、上海交通大学、香港科技大学、加州大学伯克利分校、华中科技大学等。
        //li.team3
        //  h4 团队资历
        //  p 团队曾参与<span style = "font-size: 22px; color: #9EEAFA">2015</span>年央视春晚微信电视摇红包项目，面向数亿用户构建高可用服务，对海量数据计算、云计算、机器学习等前沿技术有较为深厚的沉淀和积累。
  .ailab-wrap
    .ailab.w
      .title 携手新南威尔士大学（UNSW）
      .subtitle(style="margin-bottom: 140px") 新南威尔士大学（UNSW）为澳大利亚世界顶尖学府，其与我司AI Lab建立合作，并共同探讨产学合作
      .ailab-content
        p 2019年，去电代表清华启迪科技园人工智能企业与新南威尔士大学共创共建，建立了为期一学年的AI领域产学合作关系。
        p 去电作为清华启迪系最佳商业案例，与UNSW共享优秀人才资源并交流产学合作。其中我司代表作为讲师向UNSW研究生班开启了长达一学期的课程。
        p 预计未来数年，去电将在AI研发上投入大量资源，坚持持续科技创新，并将与更多高校及研究机构建立长期合作。
  page-belt(@showModal="showModal")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      activeTab: 0,
      coreTabs: [
        {
          title: 'AI听得清',
          icon: require('@/assets/icon-hearclearly.png'),
          items: [
            {
              icon: require('@/assets/icon-core1-1.png'),
              title: '信号处理',
              content: '基于FFT与DWT的降噪算法，大幅降低用户音频中的背景噪音。让AI听清有效信息。',
            },
            {
              icon: require('@/assets/icon-core1-2.png'),
              title: '音频端点检测',
              content: '自适应端点监测算法，语音预处理，大量减少静音片段，让AI听觉有的放矢。',
            },
            {
              icon: require('@/assets/icon-core1-3.png'),
              title: '音轨分离',
              content: '自研音轨分离技术，噪声、回声、人声多轨分离，智能降噪，回声消除。让AI听清用户诉求。',
            },
          ]
        },
        {
          title: 'AI听得懂',
          icon: require('@/assets/icon-understand.png'),
          items: [
            {
              icon: require('@/assets/icon-core2-1.png'),
              title: '“云魁”语义引擎',
              content: '基于多层神经网络，智能分析句意，结合上下文识别句中主要意图，做出符合业务场景的应答，智能互动。',
            },
            {
              icon: require('@/assets/icon-core2-2.png'),
              title: '对话决策引擎',
              content: '超过数百万条语音的样本训练集，对话决策泛化能力强，对包含重要信息的文本进行意图偏好判断。',
            },
            {
              icon: require('@/assets/icon-core2-3.png'),
              title: '行业化特征工程',
              content: '37类行业初始化训练，针对行业特性个性定义，辅助理解不同场景下相同句子的不同语义。',
            },
          ]
        },
        {
          title: 'AI答得准',
          icon: require('@/assets/icon-accuracy.png'),
          items: [
            {
              icon: require('@/assets/icon-core3-1.png'),
              title: '插话打断',
              content: '四种打断模式智能切换，真实还原对话场景。',
            },
            {
              icon: require('@/assets/icon-core3-2.png'),
              title: '模块化语料',
              content: '采用画布交互形式，话术内容随时调整，逻辑错误一秒清除，AI知错就改，应答准确。',
            },
            {
              icon: require('@/assets/icon-core3-3.png'),
              title: 'TTS/静态融合语料',
              content: '自然原声、TTS合成两种应答模式按需分配，多种多样发音人自由选择，说话清晰拟真，悦耳动听。',
            },
          ]
        },
      ],
      list: [
        {
          img: require('@/assets/core-first-1.png'),
          title: '海量标签计算',
          desc: '实时对话意图计算引擎，精准描绘用户画像'
        },
        {
          img: require('@/assets/core-first-2.png'),
          title: '用户生命周期管理',
          desc: '沉浸嵌入用户业务历程，重塑体验峰值'
        },
        {
          img: require('@/assets/core-first-3.png'),
          title: '防过频预测拦截',
          desc: '基于特征拟合真实意愿，拒绝过度营销'
        },
        {
          img: require('@/assets/core-first-4.png'),
          title: '策略计划管理',
          desc: '灵活部署经营策略，动态更新运营路径'
        }
      ],
      certificateList: [
        {
          img: require('@/assets/certificate-1.png'),
          title: '《国家信息安全等级保护三级认证》'
        },
        {
          img: require('@/assets/certificate-2.png'),
          title: '《GB/T 22080-2016 /  ISO/IEC 27001: 2013 标准》证书'
        },
        {
          img: require('@/assets/certificate-3.png'),
          title: '《ISO/IEC 20000-1:2018 标准》证书'
        },
        {
          img: require('@/assets/certificate-4.png'),
          title: '《智能客服产品能力评估证书》'
        }
      ]
    }
  },
  computed: {},
  methods: {
    handleTabClick (index) {
      this.activeTab = index
    },
    showModal (isShow) {
      this.$emit('showModal', isShow)
    }
  }
}
</script>
<style lang="stylus">
.cp-core
  background url('../../assets/core-bg4.jpg') center 3840px / 1920px no-repeat
  .page1
    min-height 1600px
    padding-top 126px
    background url('../../assets/core-group3.png') top center / 100% no-repeat
  .subtitle
    margin 24px 0
  .first-core
    .title

      margin-bottom 95px
    .list
      display flex
      align-items center
      justify-content center
      text-align center
      img
        width 307px
        object-fit contain
      .item-title
        font-size 20px
        font-weight 400
        color #FFFFFF
      .item-desc
        font-size 16px
        margin-top 11px
        line-height 22px
        color rgba(255, 255, 255, 0.6)
        padding 0 36px
  .core-tabs
    position relative
    margin-top 150px
    .tabs
      position absolute
      width 346px
      top -30px
      right -10px
      .tabs-item
        height 152px
        border-radius 8px
        display flex
        margin-bottom 20px
        justify-content center
        align-items center
        transition all .5s
        cursor pointer
        background-image linear-gradient(270deg, #27339F 0%, #2F4DB3 100%)
        &.active
          transform scale(1.08)
          background-image linear-gradient(90deg, #3D67D1 0%, #3D9DFF 100%)
          span
            color #fff
          &:hover
            transform scale(1.08)
        &:hover
          transform scale(1.02)
        span
          margin-left 14px
          font-size 30px
          color rgba(191,205,221,0.80)
        img
          height 60px

    .plan
      width 985px
      height 437px
      background url('../../assets/core-bg3.jpg')
      background-size cover
      border-radius 8px
      overflow hidden
      li
        float left
        width 160px
        margin-top 60px
        margin-left 85px
        h5
          font-size 20px
          text-align center
          margin 10px 0 30px
        img
          height 120px
          display block
          margin 0 auto
  .safe-list
    overflow hidden
    padding-top 100px
    li
      width 33%
      float left
      display flex
      align-items center
      margin-bottom 110px
      &:hover
        img
          transform rotate(-15deg) scale(1.05)
      img
        transition all .5s
        width 122px
        margin-right 28px
      .info
        width 215px
        font-size 16px
        h4
          font-size 18px
          margin-bottom 15px
  .certificate-list
    display flex
    justify-content center
    text-align center
    gap 21px
    img
      width 283px
      height 164px
    p
      margin-top 21px
      color #9EEAFA
      font-size 14px
      line-height 20px
  .team
    margin-top 80px
    li
      margin-bottom 180px
      h4
        font-size 24px
        color #9EEAFA
        margin-bottom 50px
      p
        font-size 18px
        line-height 36px
    .team1
      background url('../../assets/team1.png') top left / 613px no-repeat
      padding-left 677px
    .team2
      background url('../../assets/team2.png') top right / 637px no-repeat
      padding-right 696px
      height 320px
    .team3
      background url('../../assets/team3.png') top left / 400px no-repeat
      padding-left 564px
  .ailab-wrap
    .ailab
      padding-bottom 170px
      h3
        padding-bottom 130px
      .ailab-content
        padding 0 20px 0 460px
        background url('../../assets/ailab1.png') top left / 405px no-repeat, url('../../assets/ailab2.png') bottom right / 160px no-repeat
        height 433px
        p
          line-height 36px
          font-size 16px
</style>
